import { Avatar } from '@/common/ui/Avatar'
import { Icon } from '@/common/ui/Icon'
import { Modal } from '@/common/ui/Modal'
import { cn } from '@/common/lib/cn/cn'
import { AvatarCropUpload } from '@/common/ui/AvatarCropUpload'
import { PROFILE_AVATAR_MODAL_TOGGLE_ID, useProfileAvatar } from '../model'

export type ProfileMenuAvatarProps = {
    placeholder?: string
    imageUrl?: string | null
}

export const ProfileMenuAvatar = ({ placeholder, imageUrl }: ProfileMenuAvatarProps) => {
    const {
        seedFile,
        onSeedFileConsumed,
        isDragOver,
        isUploadPending,
        openModal,
        handleKeyDown,
        handleDragEnter,
        handleDragLeave,
        handleDragOver,
        handleDrop,
        handleExport,
    } = useProfileAvatar()

    return (
        <>
            <div
                role='button'
                tabIndex={0}
                aria-label='Изменить фото профиля'
                title='Изменить фото профиля'
                className={cn(
                    'group relative inline-flex h-[8.75rem] w-[8.75rem] shrink-0 cursor-pointer rounded-full outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent,#37cdbe)] focus-visible:ring-offset-2 focus-visible:ring-offset-[#222228]',
                    isDragOver && 'ring-2 ring-[var(--color-accent,#37cdbe)] ring-offset-2 ring-offset-[#222228]'
                )}
                onClick={openModal}
                onKeyDown={handleKeyDown}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDragOverCapture={handleDragOver}
                onDropCapture={handleDrop}
            >
                <Avatar size='xl' placeholder={placeholder} image={imageUrl ?? undefined} />
                <div
                    className='pointer-events-none absolute inset-0 flex items-center justify-center rounded-full bg-black/45 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100'
                    aria-hidden
                    aria-label='Изменить фото профиля'
                    title='Изменить фото профиля'
                >
                    <Icon name='camera' size='xl' className='text-white w-16 h-16' />
                </div>
            </div>

            <Modal id={PROFILE_AVATAR_MODAL_TOGGLE_ID} modalClassName='md:max-w-[512px] md:min-w-[512px]'>
                <h3 className='mb-4 text-lg font-bold'>Фото профиля</h3>
                <AvatarCropUpload
                    shape='circle'
                    outputSize={{ width: 512, height: 512 }}
                    disabled={isUploadPending}
                    seedFile={seedFile}
                    onSeedFileConsumed={onSeedFileConsumed}
                    onExport={handleExport}
                    exportFileName='avatar'
                />
            </Modal>
        </>
    )
}
